import React from 'react';
/*eslint import/namespace: ['error', { allowComputed: true }]*/
import * as Icon from './customIcons';
import type { Attributes, HTMLAttributes } from 'react';
import type { CustomIconType } from '../../util/types';
import type { IconProps } from './types';
import IconWrapper from './common/IconWrapper';
import { ICON_MATERIAL, ICON_MATERIAL_PERSIST_COLOR } from '../../util/data-id';

type Ref = HTMLDivElement;
type HTMLProps = Omit<HTMLAttributes<Ref>, 'color'>;
interface Props extends IconProps, HTMLProps {
  /**
   * Sets Material icon by identification name.
   * https://material.io/icons/
   */
  icon: CustomIconType;
}

const CustomIcon = React.forwardRef<Ref, Props>(({ icon, color, size, persistColor = false, ...other }: Props, ref): JSX.Element => {
  const DynamicIcon = React.createElement<Attributes & { 'data-id': string }>(Icon[icon], { 'data-id': persistColor ? ICON_MATERIAL_PERSIST_COLOR : ICON_MATERIAL });
  return (
    <IconWrapper ref={ref} color={color} size={size} {...(other as HTMLProps)}>
      {DynamicIcon as React.ReactNode}
    </IconWrapper>
  );
});

CustomIcon.displayName = 'CustomIcon';

export default CustomIcon;
